export { ProfileDropdownSuspenseWrapper as ProfileDropdown } from './profile-dropdown-suspense-wrapper';
